import { render, staticRenderFns } from "./coa.vue?vue&type=template&id=679948a3&scoped=true&"
import script from "./coa.vue?vue&type=script&lang=js&"
export * from "./coa.vue?vue&type=script&lang=js&"
import style0 from "./coa.vue?vue&type=style&index=0&id=679948a3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679948a3",
  null
  
)

export default component.exports